import { ref, onBeforeUnmount } from 'vue';
import { app } from '@ibgroup-tws-webapps/ratio.ui';

export function useSessionVisibility() {
  const isSessionVisible = ref(true);

  const bridge = app.getBridge();

  const unsubscribe = bridge?.onMessage((msg) => {
    if (msg.action === 'session_suspended') {
      isSessionVisible.value = false;
    } else if (msg.action === 'session_resumed') {
      isSessionVisible.value = true;
    }
  });

  onBeforeUnmount(() => {
    unsubscribe?.();
  });

  return {
    isSessionVisible,
  };
}
